export const getPaymentCheckout = (state) => state.paymentCheckout;
